import { z } from 'zod/v4';

export const copilotConfigOverrideSchema = z.object({
  group: z.string(),
  key: z.string(),
  value: z.string(),
});

export type CopilotConfigOverride = z.infer<typeof copilotConfigOverrideSchema>;
